import { useState } from 'react'
// Common
import { OptionWithTextItem } from '$common/option-with-text-item/option-with-text-item'
import { Switch } from '$common/switch'
// Localization
import { t } from '$i18n'

interface Props {
  muted?: boolean
  onClick: () => Promise<unknown>
}

export function NotificationButton({ onClick, muted }: Props) {
  const [disabled, setDisabled] = useState(false)
  return (
    <OptionWithTextItem
      primaryText={t('common.notifications')}
      primaryTextVariant="caption1"
      primaryTextColor="secondary"
      secondaryTextVariant="body2"
      secondaryTextColor="semiBlack"
      secondaryText={
        muted
          ? t('profile.notification.passive')
          : t('profile.notification.active')
      }
      icon={<Switch checked={!muted} disabled={disabled} />}
      onClick={() => {
        setDisabled(true)
        onClick().finally(() => setDisabled(false))
      }}
    />
  )
}
